import type { Terminology } from 'shared/hooks/useTerminology'
import { mergefield as baseMergefield } from './baseApi/mergefield'
import type { OverrideResults } from './overrideResult'

export type * from './baseApi/mergefield'

export const mergefieldApi = baseMergefield.enhanceEndpoints<
  never,
  OverrideResults<typeof baseMergefield, { getTerminology: Terminology }>
>({
  endpoints: {
    getTerminology: {
      keepUnusedDataFor: 60 * 60 * 2,
      transformResponse: ({ terminology }) => terminology,
    },
  },
})

export const {
  useGetMergeFieldFieldsQuery,
  usePostMergeFieldMutation,
  usePostMergeFieldValidationstatusMutation,
  useGetTerminologyQuery,
  useGetMergeFieldFieldsCategoryByCategoryQuery,
} = mergefieldApi
